import { render, staticRenderFns } from "./ReportPatients.vue?vue&type=template&id=0687a8c7"
import script from "./ReportPatients.vue?vue&type=script&lang=js"
export * from "./ReportPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports